/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AreaWaitingTimeResponse } from '../../models/area-waiting-time-response';
import { AreaWaitingTimeUpdate } from '../../models/area-waiting-time-update';

export interface PatchAreaWaitingTime$Params {

/**
 * Id of a resource.
 */
  id: string;
      body: AreaWaitingTimeUpdate
}

export function patchAreaWaitingTime(http: HttpClient, rootUrl: string, params: PatchAreaWaitingTime$Params, context?: HttpContext): Observable<StrictHttpResponse<AreaWaitingTimeResponse>> {
  const rb = new RequestBuilder(rootUrl, patchAreaWaitingTime.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {"style":"simple","explode":false});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AreaWaitingTimeResponse>;
    })
  );
}

patchAreaWaitingTime.PATH = '/api/v1/areas/{id}/waiting_time';
